import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Alert, Button, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const isMd = useMediaQuery("(min-width:756px)");
  const navigate = useNavigate();
  const { themeDisplay } = useSelector((state) => state.ThemeToggler);

  return (
    <div className="-mt-1 relative h-[100vh] mainBg overflow-hidden">
      {isMd ? (
        <>
          {themeDisplay === "blue" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/2-01.svg"
              alt=""
            />
          ) : themeDisplay === "green" ? (
            <img
              className="md:max-h-[90vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/3-01.svg"
              alt=""
            />
          ) : themeDisplay === "orange" ? (
            <img
              className="md:max-h-[90vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/4-01.svg"
              alt=""
            />
          ) : themeDisplay === "dark" ? (
            <img
              className="md:max-h-[90vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/5-01.svg"
              alt=""
            />
          ) : (
            <img
              className="md:max-h-[90vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/1-01.svg"
              alt=""
            />
          )}
        </>
      ) : (
        <>
          {themeDisplay === "blue" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/2.svg"
              alt=""
            />
          ) : themeDisplay === "green" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/3.svg"
              alt=""
            />
          ) : themeDisplay === "orange" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/4.svg"
              alt=""
            />
          ) : themeDisplay === "dark" ? (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/5.svg"
              alt=""
            />
          ) : (
            <img
              className="md:max-h-[60vh] md:w-[100vw] md:object-cover"
              src="/assets/images/login/1.svg"
              alt=""
            />
          )}
        </>
      )}
      <div className="absolute top-[10px] right-1/2 translate-x-1/2 bg-white p-2 rounded-md flex flex-col gap-3">
        <img
          src="/assets/images/logo.png"
          alt=""
          className="md:w-[50px] w-[40px] "
        />
      </div>
      <h1 className="absolute top-[70px] right-1/2 translate-x-1/2 text-white text-center font-bold text-lg">
        {process.env.REACT_APP_TITLE}
      </h1>
      <div className="flex absolute w-full top-1/4 left-1/2 -translate-x-1/2  flex-col gap-4 justify-center items-center">
        <Button
          sx={{
            width: "200px !important",
            height: "48px !important",
            background: (theme) =>
              theme.palette.mode === "dark"
                ? "#000 !important"
                : "#fff !important",
          }}
          onClick={() => navigate("/register-modi")}
          variant="contained"
          color="inherit"
        >
          ثبت نام مودی
        </Button>{" "}
        <Button
          sx={{
            width: "200px !important",
            height: "48px !important",
            background: (theme) =>
              theme.palette.mode === "dark"
                ? "#000 !important"
                : "#fff !important",
          }}
          onClick={() => navigate("/register")}
          variant="contained"
          color="inherit"
        >
          ثبت نام کابر
        </Button>{" "}
        <Alert
          sx={{
            margin: "0 10px",
            columnGap: 1,
            width: "max-content",
            maxWidth: "80% !important",
            color: "#fff !important",
            ".MuiAlert-icon": {
              color: "#fff !important",
            },
            background: "rgba(0,0,0,0.3)  !important",
            lineHeight: "1.9 !important",
          }}
          severity={"info"}
          variant="outlined"
        >
          <strong className="font-bold"> ثبت نام مودی</strong>: اگر هنوز به
          عنوان مودی ثبت نام نکرده اید، این گزینه را انتخاب کنید
        </Alert>
        <Alert
          sx={{
            margin: "0 10px",
            columnGap: 1,
            width: "max-content",
            maxWidth: "80% !important",
            color: "#fff !important",
            ".MuiAlert-icon": {
              color: "#fff !important",
            },
            background: "rgba(0,0,0,0.3)  !important",
            lineHeight: "1.9 !important",
          }}
          severity={"info"}
          variant="outlined"
        >
          {" "}
          <strong className="font-bold">ثبت نام کاربر:</strong> اگر در حال حاضر
          اکانت مودی دارید و نیاز به اکانت مجزا برای کاربر دیگری دارید، این
          گزینه را انتخاب کنید
        </Alert>
        {/* <Button
          sx={{
            width: "200px !important",
            height: "48px !important",
          }}
          onClick={() => navigate("/register-modi")}
          variant="outlined"
          color="primary"
        >
         
        </Button> */}
      </div>{" "}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          justifyContent: "space-between",
        }}
        className=" absolute bottom-0 right-1/2 translate-x-1/2"
      >
        <SupportAgentIcon sx={{ color: "#20a8d8" }} />
        <div className="flex flex-col items-end gap-1">
          <Typography
            component={"a"}
            href={`tel:${process.env.REACT_APP_TEL1}`}
            sx={{
              fontSize: "1rem",
              color: "#20a8d8",
              fontWeight: "bold",
            }}
          >
            {process.env.REACT_APP_TEL1}
          </Typography>{" "}
          <Typography
            component={"a"}
            href={`tel:${process.env.REACT_APP_TEL2}`}
            sx={{
              fontSize: "1rem",
              color: "#20a8d8",
              fontWeight: "bold",
              /*                         ml:"90px"
               */
            }}
          >
            {process.env.REACT_APP_TEL2}
          </Typography>
        </div>
      </Box>
    </div>
  );
};

export default SignUp;
